<section class="w-185 flex flex-col flex-wrap shadow-nx rounded-gt-md-7 p-12 box-content">
    <span class="gt-greytip-header-logo mb-12 block m-auto" *ngIf="!disableGreytHrLogo"></span>
    <div>
        <div class="account-disabled"> </div>
        <div class="mt-4">
            <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="opacity-90 text-7gpx text-text-default font-semibold font-body-semibold mb-1">
                    Sorry! It seems we are no longer together.
                </div>
                <div>
                    <a 
                        class="text-primary text-7gpx font-body cursor-pointer"
                        rel="noopener noreferrer"  target="_blank" 
                        href="https://knowledge.greythr.com/display/GOIN/Disabled+Account">
                        Get back to us
                    </a><span class="font-body opacity-90 text-7gpx text-text-default"> to fix this for you.</span>
                </div>
            </div>
        </div>
    </div>
</section>
    